import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import ModalHeader from "../../modals/modalHeader";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import { Button } from "@mui/material";
import { validateString } from "../../../common/validators";
import { StyledModalRoot } from "../../styled/modal";

export default function CreateOrEditEquipmentModal({
  equipment,
  show,
  closeModal,
  createEquipment,
  editEquipment,
}) {
  const [loading, setLoading] = useState(false);

  const [equipmentName, setEquipmentName] = useState("");
  const [isEquipmentNameValid, setIsEquipmentNameValid] = useState(false);

  const [submitted, setSubmitted] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (equipment) {
      setIsEditing(true);
      setEquipmentName(equipment.name || "");
    }
  }, [equipment]);

  const validateFields = () => {
    const nameValid = validateString(equipmentName);
    setIsEquipmentNameValid(nameValid);
    return nameValid;
  };

  const handleSubmit = () => {
    setSubmitted(true);

    if (!validateFields()) {
      return;
    }

    setLoading(true);

    const equipmentObj = {
      name: equipmentName,
    };

    if (isEditing) {
      editEquipment({ id: equipment.id, ...equipmentObj });
    } else {
      createEquipment(equipmentObj);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", height: "100vh" }}>
        <Stack
          spacing={2}
          sx={{
            m: "auto",
          }}
        >
          <CircularProgress sx={{ "&:focus-visible": { border: "none" } }} />
        </Stack>
      </Box>
    );
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={show}
      onClose={closeModal}
      closeAfterTransition
      sx={{
        zIndex: 5000,
        "&:focus-visible": {
          border: "none",
        },
      }}
    >
      <Fade in={show}>
        <StyledModalRoot height={"50%"} width={"50%"} overflow={"auto"}>
          <ModalHeader label="Equipamento" margin={0} onClose={closeModal} />
          <Box
            sx={{
              padding: 2,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <TextField
              name="equipmentName"
              required
              fullWidth
              id="equipmentName"
              label="Nome"
              value={equipmentName}
              onChange={(e) => setEquipmentName(e.target.value)}
              error={submitted && !isEquipmentNameValid}
              helperText={
                submitted && !isEquipmentNameValid && "Nome é obrigatório"
              }
              autoFocus
            />
          </Box>

          <Divider sx={{ my: 2 }} />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            sx={{ mt: 4 }}
          >
            {isEditing ? "Atualizar" : "Cadastrar"}
          </Button>
        </StyledModalRoot>
      </Fade>
    </Modal>
  );
}
